export default "__VITE_ASSET__B8uySbR7__"